import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

import { Form, Col, Card } from 'react-bootstrap';

import { campotexto, camposelect } from '../campos/campos';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { getDadosToOptions } from '../utils/toolsforms';

class DadosDeEndereco extends React.Component {

    state = {
        estadocidadetexto: false,
        estados: {},
        cidades: {}
    }

    async componentDidMount(){

        let paises = getDadosToOptions(this.props.paisespesquisa,'idpais', trad, this.props.trads,tradCampo(this.props.lingua),'SELECIONE');
        paises = paises.filter(itens => {
            return this.props.lingua==='pt'&&itens.idpais!==214?false:true;
        });
        this.paisesoptions = paises;        

        const dados_cadastrais_iniciais = this.props.form.getState().initialValues;
        
        if(dados_cadastrais_iniciais.idfisica&&dados_cadastrais_iniciais.idpais===214){
            
            const result2 = await this.props.pesquisacidade({idestado: dados_cadastrais_iniciais.idestado});
            this.setState({
                cidades: result2
            });            
        }

        const result1 = await this.props.pesquisaestados();
        this.setState({
            estados: result1            
        });
    }

    handlePaisEscolha = (value, previous) => {
        this.setState({
            estadocidadetexto: parseInt(value)===214?false:true
        });
                
        if(this.props.paisespesquisa&&this.props.paisespesquisa.length){

            const pais = this.props.paisespesquisa.filter(itens => {
                return itens.idpais === parseInt(value)
            });
            
            if(pais[0]){                                
                this.props.form.mutators.setValue('ddi', pais[0].ddi);
                this.props.form.mutators.setValue('ddicelular', pais[0].ddi);
                if(pais[0].dominio !== ''){
                    this.props.handlePesquisaQuestionario({passo: [1,6]});
                }else{
                    this.props.handlePesquisaQuestionario({passo: [1,2]});
                }
            }
        }

        if(parseInt(value)!==214){
            this.props.form.mutators.setValue('idmunicipio', '');
            this.props.form.mutators.setValue('estado', '');
        }
    }
    
    handleTipoLogradouros = (tipologs) => {        
        let result = getDadosToOptions(tipologs,'tipolog', trad, this.props.trads,'tipolog','SELECIONE');
        return result;
    }

    handleEstados = (estados) => {        
        let result = getDadosToOptions(estados,'idestado', trad, this.props.trads,'sigla','SELECIONE');
        return result;
    }

    handleCidades = (cidades) => {        
        let result = getDadosToOptions(cidades,'idmunicipio', trad, this.props.trads,'cidade','SELECIONE');
        return result;
    }

    handlePesquisaCep = (value, previous) => {        
        this.pesquisaCep(value);
    }

    pesquisaCep = async (cep = '') => {
        let ceptratado = cep;
        ceptratado = ceptratado.replace('.');
        ceptratado = ceptratado.replace('-');
        ceptratado = ceptratado.replace('/');
        ceptratado = ceptratado.replace(' ');
        
        if(ceptratado.length === 8){
            
            const dados = await this.props.pesquisacep(ceptratado);            
            if(dados.municipio){                
                this.setState({
                    estadocidadetexto: false
                });                
                this.props.form.mutators.setValue('idpais',214);
                this.props.form.mutators.setValue('ddi','55');
                this.props.form.mutators.setValue('ddicelular','55');
                this.props.form.mutators.setValue('ddd',dados.municipio.ddd);
                this.props.form.mutators.setValue('dddcelular',dados.municipio.ddd);
                this.props.form.mutators.setValue('tipologradouro',dados.tipolog);
                this.props.form.mutators.setValue('logradouro',dados.logradouro);
                this.props.form.mutators.setValue('bairro',dados.bairro);
                this.props.form.mutators.setValue('idmunicipio',dados.municipio.idmunicipio);
                this.props.form.mutators.setValue('estado',dados.municipio.idestado);                
                document.getElementsByName('numero')[0].focus();
            }else{
                const status = this.props.form.getFieldState('idpais');
                if(parseInt(status.value) === 214){
                    const result = await this.props.pesquisaestados();
                    this.setState({
                        estados: result
                    })
                }else{
                    this.setState({
                        estadocidadetexto: true
                    });
                }
            }
        }
    }

    handleFiltraCidade = async (idestado) => {
        const result = await this.props.pesquisacidade({idestado: idestado});
        this.setState({
            cidades: result
        });
    }
    
    render(){

        const trads = this.props.trads;
        const lingua = this.props.lingua;
        const cepdados = this.props.cepdados;
        
        return (
            <Card className='mb-3'>
                <Card.Header><Card.Title>{trad(trads,'ENDERECAMENTO',lingua)}</Card.Title></Card.Header>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="tipoend" style={this.props.styles['tipoend']?this.props.styles['tipoend']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TIPOEND',lingua)} 
                            options={
                                [
                                    {"texto": trad(trads,'SELECIONE',lingua), "value": ""},
                                    {"texto": trad(trads,'TITLER',lingua), "value": "R"},
                                    {"texto": trad(trads,'TITLEC',lingua), "value": "C"},                                
                                ]
                            }
                            label={trad(trads,'TIPOEND',lingua)} name='tipoend' component={camposelect} />
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="idpais" style={this.props.styles['idpais']?this.props.styles['idpais']:{}}>
                            <Field 
                            styles={this.props.styles}                         
                            placeholder={trad(trads,'TITLEPAIS',lingua)} 
                            options={this.paisesoptions?this.paisesoptions:[]}
                            label={trad(trads,'TITLEPAIS',lingua)} name='idpais' component={camposelect} />
                            <OnChange name="idpais">
                                {this.handlePaisEscolha}
                            </OnChange>
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="cep" style={this.props.styles['cep']?this.props.styles['cep']:{}}>
                            <Field type='tel' 
                            mask="99999999"
                            maskPlaceholder={null}
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLECEP',lingua)}                             
                            label={trad(trads,'TITLECEP',lingua)} name='cep' component={campotexto} />
                            <OnChange name="cep">
                                {(value, previous) => {                                    
                                    this.handlePesquisaCep(value, previous)
                                }}                                
                            </OnChange>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="tipologradouro" style={this.props.styles['tipologradouro']?this.props.styles['tipologradouro']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLETIPOLOG',lingua)} 
                            options={this.handleTipoLogradouros(this.props.tipologradouros)}
                            label={trad(trads,'TITLETIPOLOG',lingua)} name='tipologradouro' component={camposelect} />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="logradouro" style={this.props.styles['logradouro']?this.props.styles['logradouro']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLEEND',lingua)} 
                            label={trad(trads,'TITLEEND',lingua)} name='logradouro' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="1" controlId="numero" style={this.props.styles['numero']?this.props.styles['numero']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLENUMERO',lingua)}                             
                            label={trad(trads,'TITLENUMERO',lingua)} name='numero' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="bairro" style={this.props.styles['bairro']?this.props.styles['bairro']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLEBAIRRO',lingua)} 
                            label={trad(trads,'TITLEBAIRRO',lingua)} name='bairro' component={campotexto} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="2" controlId="complemento" style={this.props.styles['complemento']?this.props.styles['complemento']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLECOMPLEMENTO',lingua)} 
                            label={trad(trads,'TITLECOMPLEMENTO',lingua)} name='complemento' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="estado" style={this.props.styles['estado']?this.props.styles['estado']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLEESTADO',lingua)} 
                            options={
                                this.handleEstados(
                                    cepdados.municipio?[{idestado: cepdados.municipio.estado.idestado, sigla: cepdados.municipio.estado.sigla, selected: cepdados.municipio.estado.idestado}]
                                    :
                                    this.state.estados
                                )
                            }
                            label={trad(trads,'TITLEESTADO',lingua)} name='estado' component={this.state.estadocidadetexto?campotexto:camposelect} />
                            <OnChange name="estado">
                                {(value) => {
                                    this.handleFiltraCidade(value);
                                }}
                            </OnChange>
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="idmunicipio" style={this.props.styles['idmunicipio']?this.props.styles['idmunicipio']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLECIDADE',lingua)} 
                            options={
                                this.handleCidades(
                                    cepdados.municipio?[{idmunicipio: cepdados.municipio.idmunicipio, cidade: cepdados.municipio.cidade, selected: cepdados.municipio.idmunicipio}]
                                    :
                                    this.state.cidades
                                )
                            }
                            label={trad(trads,'TITLECIDADE',lingua)} name='idmunicipio' component={this.state.estadocidadetexto?campotexto:camposelect} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="tipotel" style={this.props.styles['tipotel']?this.props.styles['tipotel']:{}}>
                            <Field 
                            styles={this.props.styles}
                            placeholder={trad(trads,'TIPOTEL',lingua)} 
                            options={
                                [
                                    {"texto": trad(trads,'SELECIONE',lingua), "value": ""},
                                    {"texto": trad(trads,'TITLER',lingua), "value": "R"},
                                    {"texto": trad(trads,'TITLEC',lingua), "value": "C"},                                
                                ]
                            }
                            label={trad(trads,'TIPOTEL',lingua)} name='tipotel' component={camposelect} />
                        </Form.Group>
                        <Form.Group as={Col} md="1" controlId="ddi" style={this.props.styles['ddi']?this.props.styles['ddi']:{}}>
                            <Field type='text'
                            mask="999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'DDI',lingua)} 
                            label={trad(trads,'DDI',lingua)} name='ddi' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="1" controlId="ddd" style={this.props.styles['ddd']?this.props.styles['ddd']:{}}>
                            <Field type='text' 
                            styles={this.props.styles}
                            placeholder={trad(trads,'DDD',lingua)} 
                            label={trad(trads,'DDD',lingua)} name='ddd' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="telefone" style={this.props.styles['telefone']?this.props.styles['telefone']:{}}>
                            <Field type='text' 
                            mask="99999999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLETEL',lingua)} 
                            label={trad(trads,'TITLETEL',lingua)} name='telefone' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="1" controlId="ddicelular" style={this.props.styles['ddicelular']?this.props.styles['ddicelular']:{}}>
                            <Field type='text' 
                            mask="999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'DDI',lingua)} 
                            label={trad(trads,'DDI',lingua)} name='ddicelular' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="1" controlId="dddcelular" style={this.props.styles['dddcelular']?this.props.styles['dddcelular']:{}}>
                            <Field type='text' 
                            mask="999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'DDDCEL',lingua)} 
                            label={trad(trads,'DDDCEL',lingua)} name='dddcelular' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="2" controlId="celular" style={this.props.styles['celular']?this.props.styles['celular']:{}}>
                            <Field type='text' 
                            mask="999999999"
                            styles={this.props.styles}
                            placeholder={trad(trads,'TITLECEL',lingua)} 
                            label={trad(trads,'TITLECEL',lingua)} name='celular' component={campotexto} />
                        </Form.Group>
                    </Form.Row>
                </Card.Body>
            </Card>
        );
    }
}

export default DadosDeEndereco;